module.exports = " <div class=brandmark> <v-head></v-head> <div class=brandmark_content> <div class=brandmark_content_one> <img src=" + require("../../../static/images/broadcast_banner.jpg") + " alt=\"\"> </div> {{{brandmark}}} </div> <v-footer></v-footer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brandmark/brandmark.vue
// module id = 54
// module chunks = 1